/* eslint-disable no-useless-escape */
import React from 'react'
import { Field } from 'redux-form'

// Components
import ReduxFormInput from './ReduxFormInput'

// Helpers
import {
  required,
  ratioFormat,
  baseballAverageFormat,
  ERAFormat,
  inningsPitchedFormat,
  distanceMetersFormat,
  finishTimeFormat,
  percentageFormat,
  fieldGoalDistancesFormat,
  penaltyTimeFormat,
  setScoreFormat,
  feetAndInchesFormat,
  volleyballPlayedAndStartedFormat,
  winLossFormat
} from '../../../utils/formValidators'

export const number = ({ field, index, fields }) => (
  <Field
    name={field + '.value'}
    component={ReduxFormInput}
    type="number"
    label={fields.get(index).name}
    placeholder={"0"}
    validate={required} />
)

export const text = ({ field, index, fields }) => (
  <Field
    name={field + '.value'}
    component={ReduxFormInput}
    type="text"
    label={fields.get(index).name}
    validate={required} />
)

export const ratio = ({ field, index, fields}) => (
  <Field
    name={field + '.value'}
    component={ReduxFormInput}
    type="text"
    label={fields.get(index).name}
    placeholder={'1/2'}
    validate={ratioFormat}
    parse={(value) => value.replace(/[^\d\/]/g, "")} />
)

export const baseballAverage = ({ field, index, fields }) => (
  <Field
    name={field + '.value'}
    component={ReduxFormInput}
    type="number"
    label={fields.get(index).name}
    placeholder={'.265'}
    validate={baseballAverageFormat}
    parse={(value) => value.replace(/[^\.\d]/g, "")} />
)

export const ERA = ({ field, index, fields }) => (
  <Field
    name={field + '.value'}
    component={ReduxFormInput}
    type="number"
    label={fields.get(index).name}
    placeholder={'2.25'}
    validate={ERAFormat}
    parse={(value) => value.replace(/[^\.\d]/g, "")} />
)

export const inningsPitched = ({ field, index, fields }) => (
  <Field
    name={field + '.value'}
    component={ReduxFormInput}
    type="text"
    label={fields.get(index).name}
    placeholder={'5 2/3'}
    validate={inningsPitchedFormat}
    parse={(value) => value.replace(/[^\d\/\s]/g, "")} />
)

export const distanceMeters = ({ field, index, fields }) => (
  <Field
    name={field + '.value'}
    component={ReduxFormInput}
    type="text"
    label={fields.get(index).name}
    placeholder={'5000m'}
    validate={distanceMetersFormat}
    parse={(value) => value.replace(/[^\dm]/g, "")} />
)

export const finishTime = ({ field, index, fields }) => (
  <Field
    name={field + '.value'}
    component={ReduxFormInput}
    type="text"
    label={fields.get(index).name}
    placeholder={'00:00.00'}
    validate={finishTimeFormat}
    parse={(value) => value.replace(/[^\d:\.]/g, "")} />
)

export const percentage = ({ field, index, fields }) => (
  <Field
    name={field + '.value'}
    component={ReduxFormInput}
    type="number"
    label={fields.get(index).name}
    placeholder={'75.00'}
    validate={percentageFormat}
    parse={(value) => value.replace(/[^\d\.]/g, "")} />
)

export const fieldGoalDistances = ({ field, index, fields }) => (
  <Field
    name={field + '.value'}
    component={ReduxFormInput}
    type="text"
    label={fields.get(index).name}
    placeholder={'35, 40, 45'}
    validate={fieldGoalDistancesFormat}
    parse={(value) => value.replace(/[^\d, ]/g, "")} />
)

export const penaltyTime = ({ field, index, fields }) => (
  <Field
    name={field + '.value'}
    component={ReduxFormInput}
    type="text"
    label={fields.get(index).name}
    placeholder={'02:00'}
    validate={penaltyTimeFormat}
    parse={(value) => value.replace(/[^\d:]/g, "")} />
)

export const setScore = ({ field, index, fields }) => (
  <Field
    name={field + '.value'}
    component={ReduxFormInput}
    type="text"
    label={fields.get(index).name}
    placeholder={'2:1'}
    validate={setScoreFormat}
    parse={(value) => value.replace(/[^\d:]/g, "")} />
)

export const feetAndInches = ({ field, index, fields }) => (
  <Field
    name={field + '.value'}
    component={ReduxFormInput}
    type="text"
    label={fields.get(index).name}
    placeholder={'5\' 2 1/2"'}
    validate={feetAndInchesFormat}
    parse={(value) => value.replace(/[^\d '"\/]/g, "")} />
)

export const volleyballPlayedAndStarted = ({ field, index, fields }) => (
  <Field
    name={field + '.value'}
    component={ReduxFormInput}
    type="text"
    label={fields.get(index).name}
    placeholder={'3-1-1'}
    validate={volleyballPlayedAndStartedFormat}
    parse={(value) => value.replace(/[^\d\-]/g, "")} />
)

export const winLoss = ({ field, index, fields}) => (
  <Field
    name={field + '.value'}
    component={ReduxFormInput}
    type="text"
    label={fields.get(index).name}
    placeholder={'1/0'}
    validate={winLossFormat}
    parse={(value) => value.replace(/[^10\/]/g, "")} />
)



// WEBPACK FOOTER //
// ./src/components/Global/ReduxForms/StatFields.js